import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { NewStreamEventComponent } from './new-stream-event/new-stream-event.component';
import { EditStreamEventComponent } from './edit-stream-event/edit-stream-event.component';
import { PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { UntypedFormControl } from '@angular/forms';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { MatDialog } from '@angular/material/dialog';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'vex-stream-event',
  templateUrl: './stream-event.component.html',
  styleUrls: ['./stream-event.component.scss']
})
export class StreamEventComponent implements OnInit {
  searchCtrl = new UntypedFormControl();
  pageSize = 10;
  pageNumber = 1;
  pageSizeOptions: number[] = [5, 10, 15, 50];
  lunghezza: any;
  dataSource: MatTableDataSource<any> | null
  displayedColumns: string[] = ['title', 'acceptance', 'date', 'hour', 'actions'];
  events;
  @ViewChild(MatTable) table: MatTable<any>;

  constructor(public translate: TranslateService, public guiService: GuiService, private restService: RestService, private dialog: MatDialog, private excelService: ExcelService) { }

  ngOnInit(): void {
    if (this.guiService.userLogged) {
      this.search();
    } else {
      this.getCurrent();
    }
  }

  getCurrent() {
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.search();
    })
  }

  search(){
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: this.pageNumber,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };
    this.searchCtrl.value && this.searchCtrl.value !== '' ? (param['langKey'] = this.translate.currentLang.toUpperCase(), param['i18nTitleFilter'] = this.searchCtrl.value) : null;

    this.restService.postService('node', '/stream-event-pag',param).subscribe((ris)=>{
      this.events = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.events;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  reload() {
    this.searchCtrl.reset();

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: 1,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };

    this.restService.postService('node', '/stream-event-pag',param).subscribe((ris)=>{
      this.events = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.events;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  resetPage() {
    this.pageNumber = 1;
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.search();
  }

  createEvent() {
    this.dialog.open(NewStreamEventComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.search();
      }
    })
  }

  deleteEvent(id) {
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'node-delete-event',
        id: id
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.search()
      }
    })
  }

  editEvent(item?: any['item']) {
    this.dialog.open(EditStreamEventComponent, {
      data: item || null,
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((program) => {
      if (program == 'done') {
        this.search()
      }
    })
  }

  downloadAcceptance(item){
    this.excelService.exportAsExcelFile(item.acceptation, "Event streaming report_"+item.i18nTitle[this.translate.currentLang.toUpperCase()]);
  }

  formatDateCustom(date: string): string {
    const datePart = date.split('T')[0];
    const [year, month, day] = datePart.split('-');
    return day+'/'+month+'/'+year;
  }
}
